import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconNotePadColored: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        d="M25.5261 2.44153L2.84144 6.84027C2.56912 6.89308 2.39113 7.15664 2.44387 7.42908L7.12955 31.5931C7.18237 31.8654 7.44593 32.0434 7.71836 31.9907L24.0332 28.827L29.5654 20.6334L26.1149 2.83903C26.062 2.56678 25.7985 2.38871 25.5261 2.44153Z"
        fill="#F54E95"
      />
      <path
        d="M24.0333 28.827L29.5654 20.6333L23.1956 21.8685C22.9233 21.9213 22.7453 22.1849 22.7981 22.4573L24.0333 28.827Z"
        fill="#F082A6"
      />
      <path
        d="M6.5323 6.12465L9.08742 11.0512L14.613 10.0465L15.0105 4.48059L6.5323 6.12465Z"
        fill="#F082A6"
      />
      <path
        d="M15.3524 0.0594374C15.1891 -0.0279374 14.9909 -0.0184375 14.8368 0.0843748L13.6084 0.903311L12.38 0.0843748C12.2112 -0.0281249 11.9914 -0.0281249 11.8227 0.0843748L10.5944 0.903311L9.36599 0.0843748C9.03811 -0.134187 8.58505 0.109375 8.58505 0.502311V10.5489C8.58505 10.8264 8.80999 11.0512 9.08736 11.0512H15.1153C15.3927 11.0512 15.6176 10.8263 15.6176 10.5489V0.502311C15.6177 0.317124 15.5157 0.146875 15.3524 0.0594374Z"
        fill="#FCDE76"
      />
    </Icon>
  );
};

export default IconNotePadColored;
